// GlobalContext.tsx
"use client";
import { createContext, useState, ReactNode, useContext, useMemo, useEffect } from "react";
// Locale
import  locale from "@/locales"; 


// Define the shape of the context data
interface LanguageContextType {
  languageText: any;
  setLanguageText: React.Dispatch<React.SetStateAction<any>>;
}

// Create the context
const LanguageContext = createContext<LanguageContextType | undefined>(
  undefined
);

// Provider component
export const LanguageStateProvider = ({ children }: { children: ReactNode }) => {
  
  const [languageText, setLanguageText] = useState<any>(null);
  const ContextValue = useMemo(
    () => ({
      languageText,
      setLanguageText
    }),
    [
      languageText,
      setLanguageText
    ]
  );

  useEffect(() => {
    locale.then((languageModule) => {
      setLanguageText(languageModule);
    });
  }, [])
  

  return (
    <LanguageContext.Provider value={ContextValue}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook to use the GlobalContext
export const useLanguageContext = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error(
      "useLanguageContext must be used within a LanguageStateProvider"
    );
  }
  return context;
};
